import {all, put, takeLatest} from "redux-saga/effects";
import {init_error, init_session, userProfileResolved} from "./session_state_reducer";
import {supabase} from "../supabase";
import {PostgrestError} from "@supabase/supabase-js";
import {CurrentUserInfo} from "./index";
import {PayloadAction} from "@reduxjs/toolkit";


export const REFRESH_INTERVAL = 3000;

export function* onInit(action: PayloadAction<string>) {

    try {

        const {data, error}: {
            data: CurrentUserInfo,
            error: PostgrestError
        } = yield supabase.from("profile").select("id,fullName,avatarUrl,defaultWorkerID,worker(*),userRoles(roles)").eq("id", action.payload).single();
        if (error) {
            yield put(init_error(error.message));
            return;
        }
        yield put(userProfileResolved(data));

    } catch (e) {
        // @ts-ignore
        yield put(init_error(`${e && e.message}`));
    }

}


export function* session_saga() {
    yield all([
        takeLatest(init_session, onInit),
    ]);


}
